/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CompanyType = {
    ShippingLine: 'ShippingLine',
    Shipper: 'Shipper',
    Consignee: 'Consignee',
    Forwarder: 'Forwarder',
    ShippingAgent: 'ShippingAgent',
    VesselOperator: 'VesselOperator',
    TransportCompany: 'TransportCompany',
    CustomsClearanceAgent: 'CustomsClearanceAgent',
    TerminalOperator: 'TerminalOperator',
    TrainOperator: 'TrainOperator',
    Other: 'Other',
} as const;

export type CompanyType = typeof CompanyType[keyof typeof CompanyType];



